import { NgModule } from '@angular/core';
import { HomeModule } from '../home/home.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnlinecalcRoutingModule } from './onlinecalc-routing.module';
import { NotificationModule } from '../notification.module';
import { NotificationService } from '../service/notification.service';
import { MaterialModule } from '../material/material.module';
import { ManagecalcComponent } from './managecalc/managecalc.component';
import { CommonModule } from '@angular/common';
import { CalrunidsComponent } from './calrunids/calrunids.component';
import { UserControlComponent } from './user-control/user-control.component';
import { AddCalcRunComponent } from './add-calc-run/add-calc-run.component';
import { CalcstatusComponent } from './calcstatus/calcstatus.component';


@NgModule({
  declarations: [
    ManagecalcComponent,
    CalrunidsComponent,
    UserControlComponent,
    AddCalcRunComponent,
    CalcstatusComponent
  ],
  imports: [
    CommonModule,
    OnlinecalcRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationModule,
    MaterialModule
  ],
  providers: [NotificationService]
})
export class OnlinecalcModule { }
